module.exports = __webpack_public_path__ + "img/bsidd-5.fd76c90d.jpg";